import { render } from "./BaseRoundRectButton.vue?vue&type=template&id=b21dae08&scoped=true&ts=true&lang=pug"
import script from "./BaseRoundRectButton.vue?vue&type=script&lang=ts"
export * from "./BaseRoundRectButton.vue?vue&type=script&lang=ts"

import "./BaseRoundRectButton.vue?vue&type=style&index=0&id=b21dae08&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b21dae08"]])

export default __exports__